const footerData = {
  terms: {
    title: "Terms of Service",
    description:
      "By using our Chrome extensions ('Extensions'), you agree to the following terms:",
    conditions: [
      "The Extensions are provided 'as is', without any warranties, express or implied.",
      "You are solely responsible for how you use the Extensions.",
      "The developers are not liable for any damages or consequences resulting from their use.",
    ],
    btnBack: "Back",
  },
  policy: {
    title: "Privacy Policy",
    description:
      "We respect your privacy. Our extensions do not collect, store, or transmit any personal data. All operations are performed locally in your browsers.",
    btnBack: "Back",
  },
  contact: {
    title: "Contact",
    description:
      "If you have any questions, suggestions, or need support — please contact us via email: autorefreshtasks@gmail.com",
    btnBack: "Back",
  },
  donate: {
    paypal: "PayPal: greendaycom1@gmail.com",
    crypto:
      "Crypto wallet: USDT Tron (TRC20) TAoe3vWgCREzEAPDiD5L6p2s1C3bxNiEq5",
    btnBack: "Back",
  },
};

export default footerData;
